import { __spreadArrays } from "tslib";
import { accessValueString, replaceValueInObject as setLense, } from './feedUtils';
import { layoutMatcher } from 'shared/layoutMatcher';
import { debug, getWindowSize } from 'shared/utils';
export function processBindings(_a) {
    var ad = _a.ad, _b = _a.adSize, adSize = _b === void 0 ? getWindowSize() : _b, responses = _a.responses;
    if (!ad.feed) {
        return ad;
    }
    var currentLayoutId = layoutMatcher(adSize.width, adSize.height, Object.values(ad.layouts)).id;
    return Object.values(ad.conditionalStates).reduce(function (carrier, cs) {
        var csId = cs.id, bindingPairs = cs.bindingPairs;
        // do nothing when no feed binding pair
        if (!bindingPairs || Object.keys(bindingPairs).length === 0) {
            return carrier;
        }
        // place feed values into Ad
        return Object.keys(bindingPairs).reduce(function (subCarrier, pairId) {
            var _a = bindingPairs[pairId], urlId = _a.urlId, keyPath = _a.keyPath, feedPath = _a.feedPath;
            var keyPathString = keyPath.join('.');
            var _b = csId.split('_'), symbolId = _b[0], layoutId = _b[1];
            // get feed value from the response json
            var feedValue = accessValueString(responses[urlId], feedPath);
            // no feed value, do nothing, keep the original
            if (feedValue === undefined) {
                debug('undefined feedValue');
                return subCarrier;
            }
            // replace feed clickUrl value into symbol's clickUrl
            if (keyPathString === 'clickUrl') {
                // ensure the correct layout
                if (currentLayoutId !== layoutId) {
                    return subCarrier;
                }
                return setLense(['symbols', symbolId, 'clickUrl'])(subCarrier, feedValue);
            }
            // replace feed value into conditional state
            return setLense(__spreadArrays(['conditionalStates', csId], keyPath))(subCarrier, feedValue);
        }, carrier);
    }, ad);
}
